
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Group } from '../../../models/group.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import * as _ from 'lodash';
import { GroupAssociationFee } from '../../../models/group-association-fee.model';

@Component({
    selector: 'create-edit-group-modal',
    template: require('./create-edit-group-modal.component.html'),
    styles: [require('./create-edit-group-modal.component.css')]
})
export class CreateEditGroupModalComponent {
    currentGroup: Group;
    isCreatNew: boolean;
    associationFees = [];
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditGroupModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentGroup.groupId == undefined);
        this.currentGroup = data.currentGroup;
        this.getAssociationFees();
    }

    getAssociationFees() {
        this.apiService.getAssociationFees().subscribe(r => {
            console.log(r)
            this.associationFees = r;
        })
    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateGroup(this.currentGroup).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Group successfully");
                }
            });
        } else {
            this.apiService.createGroup(this.currentGroup).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create Group successfully");
                }
            });
        }
    }

    addFee() {
        if (!this.currentGroup.groupAssociationFees) {
            this.currentGroup.groupAssociationFees = [];
        }
        //if (_.some(this.currentGroup.groupAssociationFees, { associationFeeId: af.associationFeeId}) ) {
        //    this.alertService.showMessage("this fee was added already!", "", MessageSeverity.error)
        //    return;
        //}
        this.currentGroup.groupAssociationFees.push({} as any);
    }

    removeFee(index) {
        this.currentGroup.groupAssociationFees.splice(index, 1)
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/groups/create-edit-group-modal/create-edit-group-modal.component.ts